//@flow
import styled from "styled-components"
import theme from "../Theme"

const FormGroup = styled.div`
  display: flex;
  margin-bottom: 1rem;
  flex-direction: column;
`

FormGroup.defaultProps = { theme }

export default FormGroup



// WEBPACK FOOTER //
// ./src/UI/Form/FormGroup.js